import React from 'react';
import '../Partners.css';

const Partners = () => {
  const partners = [
    { id: 1, name: 'Samsung Display', logo: '/collabo_ssdisplay.png' },
    { id: 2, name: 'SK Hynix', logo: '/collabo_skhynix.png' },
    { id: 3, name: 'Hyundai Construction', logo: '/collabo_hyundai.png' },
    { id: 4, name: 'POSCO E&C', logo: '/collabo_posco.png' },
    { id: 5, name: 'DAEWOO E&C', logo: '/collabo_daewoo.png' },
    { id: 6, name: 'GS Construction', logo: '/collabo_gs.png' },
    { id: 7, name: 'DL E&C', logo: '/collabo_dl.png' },
    { id: 8, name: 'SK EcoPlant', logo: '/collabo_skeco.png' }
  ];

  return (
    <section className="partners" id="partners">
      <div className="partners-container">
        <div className="partners-header">
          <h2 className="partners-title">Major Partners</h2>
          <p className="partners-subtitle">Growing together with trusted partners worldwide</p>
        </div>

        <div className="partners-grid">
          {partners.map((partner) => (
            <div key={partner.id} className="partner-item">
              <div className="partner-logo">
                <img src={partner.logo} alt={partner.name} className="partner-image" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
